import { useTranslation } from "react-i18next";
import LeafDateTime from "../../../../../common/leaf/LeafDateTime/LeafDateTime";
import ABOName from "../../../../ABOProfile/ABOName/ABOName";
import CustomerTags from "../../../CustomerTags/CustomerTags";
import DecodeStoredCountryCode from "../../../../ABOProfile/DecodeStoredCountryCode/DecodeStoredCountryCode";
import { useAppSelector } from "../../../../../store";
import defaultContent from "../../../../../content/profile";
import "./CustomerProfileHeader.scss";
import { useGetProfileQuery } from "../../../../../services/Profile/profileAPI";
import ProfileLoader from "../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import { profileHeaderErrorTrack } from "../../../../../common/tealium/CustomerProfile/Profile/ProfileHeaderTrack";
import { storedLocale } from "../../../../Authentication/util";
import { ErrorTile } from "../../../../../common/components/ErrorTile/ErrorTile";
import maskAboNumber from "../../../../../common/util/maskAboNumber";

const CustomerProfileHeader = () => {
  const { t } = useTranslation(["profile"]);

  const affAbo = useAppSelector((state) => state.profile.affAbo);
  const isConfidentialView = useAppSelector((state) => state.profile.confidentialView);
  const isConfidentialCustomer = useAppSelector((state) => state.profile.isConfidentialCustomer) ?? false;
  const showNewCustomerName = isConfidentialView && !isConfidentialCustomer;
  const { selectedPeriod } = useAppSelector(({ period }) => period);
  const boot = useAppSelector(({ boot }) => boot);

  const showEntryDate = boot?.configuration?.profile?.customerInfo?.showEntryDate;
  const showVerifiedTag = boot?.configuration?.globalCML?.customerList?.showVerifiedTag;
  const showCSIInfo = useAppSelector(({ profileOrders }) => profileOrders.showCSIInfo);

  const { isFetching, isError, data, refetch } = useGetProfileQuery({ period: selectedPeriod, affAbo });

  const isMaskConfidentialAboNumber =
    useAppSelector((s) => s.boot.configuration.profile.maskConfidentialAboNumber) ?? false;

  if (isFetching === false && data?.aboInfo) {
    const {
      aboNo,
      name,
      localName,
      privacyFlag,
      verifiedCustomerFlag,
      entryDate,
      countryCode,
      isNew,
      isNewMigrated,
      businessNatureCode,
      isoLanguageCode,
      isNewInCurrentMonth,
      registrationChannelCd,
    } = data.aboInfo;

    return (
      <>
        <div className="customer-profile-header__abo-tag">
          {privacyFlag === false && !isConfidentialView && (
            <CustomerTags
              vcsFlag={verifiedCustomerFlag}
              isNewCustomer={isNew}
              isNewMigrated={isNewMigrated}
              businessNatureCode={businessNatureCode}
              isNewInCurrentMonth={isNewInCurrentMonth}
              selectedPeriod={selectedPeriod}
              showVerifiedTag={showCSIInfo && showVerifiedTag}
              registrationChannelCd={registrationChannelCd}
              aboNo={`profile_${aboNo}`}
            />
          )}
        </div>
        <div className="customer-profile-header__abo-name">
          <ABOName
            name={showNewCustomerName ? `${t("newCustomer", defaultContent["customerProfile"]["newCustomer"])}` : name}
            localName={
              showNewCustomerName ? `${t("newCustomer", defaultContent["customerProfile"]["newCustomer"])}` : localName
            }
            privacyFlag={showNewCustomerName ? false : isConfidentialCustomer || privacyFlag}
            languageCode={isoLanguageCode}
            fontSize="large"
            fontWeight="bold"
            locale={storedLocale()}
          />
          <div className="customer-profile-header__abo-number-and-date">
            <span className="customer-profile-header__abo-number">
              {isMaskConfidentialAboNumber && (privacyFlag || isConfidentialView) ? maskAboNumber(aboNo) : aboNo}
            </span>
            {privacyFlag === false && showEntryDate === true && (
              <p>
                -{" "}
                {`${t("customerProfile.customerRegistered", defaultContent["customerProfile"]["customerRegistered"])}`}
                <span className="customer-profile-header__registration-date">
                  <LeafDateTime date={entryDate} options={{ month: "long", day: "numeric", year: "numeric" }} />
                </span>
              </p>
            )}
          </div>
          <div className="customer-profile-header__abo-address">
            <DecodeStoredCountryCode countryCode={countryCode} />
          </div>
        </div>
      </>
    );
  }

  if (isError === true) {
    profileHeaderErrorTrack();
  }

  return (
    <>
      <ErrorTile
        clickFunction={refetch}
        errorStatus={isError}
        isLoading={isFetching}
        tealiumTrackId="customer-profile-header"
      />
      <ProfileLoader row={1} isFetching={isFetching} />
    </>
  );
};

export default CustomerProfileHeader;
